// extracted by mini-css-extract-plugin
module.exports = {"form":"EditForm_form__3eDTV","textarea":"EditForm_textarea__2HouB"};